import { render } from "./Additional.vue?vue&type=template&id=5fe7b3a6&scoped=true"
import script from "./Additional.vue?vue&type=script&lang=js"
export * from "./Additional.vue?vue&type=script&lang=js"

import "./Additional.vue?vue&type=style&index=0&id=5fe7b3a6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe7b3a6"]])

export default __exports__